import { Component, TemplateRef, ViewChild, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, EMPTY, first, tap } from 'rxjs';
import { ChangePasswordFormModel } from 'src/app/core/models/user/change-password-form.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrl: './change-password.component.scss',
    providers: [ChangePasswordFormModel],
    standalone: false
})
export class ChangePasswordComponent {
  formModel = inject(ChangePasswordFormModel);
  private readonly authService = inject(AuthService);
  private readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);

  @ViewChild('dangerTpl')
  public dangerTpl!: TemplateRef<unknown>;
  public callbackError?: string;

  @ViewChild('successTpl')
  public successTpl!: TemplateRef<unknown>;
  public message = '';

  public submitForm(): void {
    this.authService
      .changePassword(this.formModel.form.getRawValue())
      .pipe(
        first(),
        tap(() => {
          this.message = this.translateService.instant(
            'MESSAGES.PASSWORD_SUCCESSFULLY_CHANGED',
          );

          this.toastService.show({
            template: this.successTpl,
            className: 'bg-success text-light',
          });
        }),
        catchError(() => {
          const translatedMessage = this.translateService.instant(
            'ERRORS.CHANGE_PASSWORD',
          );

          this.callbackError = translatedMessage;

          this.toastService.show({
            template: this.dangerTpl,
            className: 'bg-danger text-light',
          });

          return EMPTY;
        }),
      )
      .subscribe();
  }
}
